import { memo } from 'react';

import './custom.scss';

import { useConfig } from '../../../../context/config-provider';
import { Image } from '../../../image/image';

function CustomUI() {
  const { site } = useConfig();
  const { url, image, images, file } = site?.license ?? {};

  return (
    <div className="sb-Footer-license sb-CustomLicense">
      <a href={url || file?.url} rel="noreferrer" target="_blank">
        <Image alt={image.alt || file?.alt} className="sb-Footer-iconLicense" loading="lazy" src={image.url} />
      </a>
      {images.length > 0 && (
        <div className="sb-Footer-minIcons">
          {images.map(imageItem => (
            <Image
              key={imageItem.id}
              alt={imageItem.alt}
              className="sb-Footer-minIcon"
              loading="lazy"
              src={imageItem.url}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export const Custom = memo(CustomUI);
